import React, { useState } from 'react';
import { Table } from 'components';
import moment from 'moment';
import Config from 'config';
import DocumentPreviewModal from './DocumentPreviewModal';

const ExpandedDocumentsTable = ({ _this, documents = [] }) => {
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [showDocumentPreviewModalOpen, setShowDocumentPreviewModalOpen] = useState(false);

  if (!_this.currentDocuments?.length) {
    return <div className="text-gray-500 italic">No documents available.</div>;
  }

  // Helper: generate inline preview URL
  const getPreviewUrl = (fileUrl) => {
    const lower = fileUrl.toLowerCase();
    const inlineUrl = `${Config.API_URL}v1/public/view-file-inline?file_url=${encodeURIComponent(
      fileUrl
    )}`;
    if (/\.(pdf|jpg|jpeg|png|gif)$/i.test(lower)) {
      return inlineUrl;
    }
    // Fallback for other formats
    return `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(fileUrl)}`;
  };

  const handleOpenModal = (doc) => {
    const previewUrl = getPreviewUrl(doc.file_url);
    setSelectedDoc({ ...doc, previewUrl });
    setShowDocumentPreviewModalOpen(true);
  };

  const documentColumns = [
    { Header: 'Document Title', accessor: 'message' },
    {
      Header: 'File',
      accessor: 'file_url',
      Cell: (row) => (
        <span
          className="text-blue-500 underline cursor-pointer"
          onClick={() => handleOpenModal(row.original)}
        >
          View File
        </span>
      )
    },
    {
      Header: 'Created On',
      accessor: 'createdAt',
      Cell: (row) => <div>{moment(row.original.createdAt).format('YYYY-MM-DD')}</div>
    }
  ];

  return (
    <>
      <div className="relative">
        <Table
          keyField="_id"
          columns={documentColumns}
          data={_this.currentDocuments}
          headerComponent={null}
          minRows={1}
          showPagination={false}
        />
      </div>

      {/* Modal */}
      <DocumentPreviewModal
        _this={{
          ..._this,
          showDocumentPreviewModalOpen,
          setShowDocumentPreviewModalOpen,
          selectedDoc
        }}
      />
    </>
  );
};

export default ExpandedDocumentsTable;
